import { animation, colors } from '../../styles';

export const primaryButtonStyles = `
cursor: pointer;
display: inline-block;
border: 0;
padding: 16px 20px;
background-color: ${colors.buttonDefault};
color: ${colors.pureWhite};
font-size: 14px;
line-height: normal;
text-decoration: none;
text-transform: uppercase;
font-weight: 900;
outline: 0;
font-family: Lato Black, sans-serif;

transition: all ${animation.general.durationAndTiming};

&:hover {
  background-color: ${colors.buttonHover};
}

&:disabled {
  background-color: ${colors.buttonDisabled};
}
`;

export const secondaryButtonStyles = `
cursor: pointer;
display: inline-block;
border: 2px solid ${colors.buttonDefault};
padding: 14px 18px;
background-color: transparent;
color: ${colors.buttonDefault};
font-size: 14px;
line-height: normal;
text-decoration: none;
text-transform: uppercase;
font-weight: 900;
outline: 0;
font-family: 'Lato Black', sans-serif;

transition: all ${animation.general.durationAndTiming};

&:hover {
  color: ${colors.buttonHover};
  border-color:${colors.buttonHover};
}

&:disabled {
  color: ${colors.buttonDisabled};
  background-color: ${colors.buttonDisabled};
}
`;

export const whitepaperButtonStyles = `
  ${secondaryButtonStyles};
  background-color: ${colors.pureWhite};
  color: ${colors.buttonDefault}
  
  &:hover {
    color: ${colors.buttonHover};
    border-color:${colors.pureWhite};
  }
  
  &:disabled {
    color: ${colors.buttonDisabled};
    background-color: ${colors.buttonDisabled};
  }
`;

export const pillButtonStyles = `
cursor: pointer;
display: inline-block;
border: 1px solid ${colors.gray3};
padding: 16px 20px;
background-color: transparent;
color: ${colors.gray1};
font-size: 14px;
line-height: normal;
text-decoration: none;
font-weight: 900;
font-family: Lato Black, sans-serif;
outline: 0;
transition: all ${animation.general.durationAndTiming};
border-radius: 25px;

&:hover {
  background-color: ${colors.crederaRed} !important;
  border-color: ${colors.crederaRed} !important;
  color: ${colors.pureWhite} !important;
}
`;
